// Nav scroll effect
  const nav = document.getElementById('nav');
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 20);
  });

  // Reveal on scroll
  const reveals = document.querySelectorAll('.reveal');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); }});
  }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
  reveals.forEach(el => observer.observe(el));

  // Sticky CTA visibility (mobile)
  const stickyCta = document.getElementById('stickyCta');
  const heroSection = document.querySelector('.hero');
  const stickyObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (window.innerWidth <= 900) {
        stickyCta.style.transform = e.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
        stickyCta.style.transition = 'transform 0.3s ease';
      }
    });
  }, { threshold: 0.1 });
  stickyObserver.observe(heroSection);